module.exports = __webpack_public_path__ + "caf80d5d.png";